import { DotsLoader, Sidecar } from '@eppendorf/vnls-react-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { InvitationStatus } from 'src/features/organizations/detail/detail-tab/invitation-status';
import { SIDECAR_ROUTE_PARAMS } from 'src/sidecar-route-params';
import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { SidecarRouterOutlet } from '$components/sidecar-router/sidecar-router-outlet';
import { useSidecar } from '$components/sidecar-router/use-sidecar.hook';
import { TabsNavigationSidecar } from '$components/tabs';
import useOrganizationDetailStore from '$context/organization-detail-context';
import { useGetOrganization } from '$features/organizations/organizations.api';

export function OrganizationDetailWrapper() {
  const { t } = useTranslation();
  const [search] = useSearchParams();
  const { isSidecarOpen, handleSidecarOpenChange } = useSidecar();
  const { isEditMode, isDirty } = useOrganizationDetailStore();

  const {
    data: organization,
    isError,
    isLoading: isLoadingOrganization,
  } = useGetOrganization(search.get(SIDECAR_ROUTE_PARAMS.organization.id) || '');

  const handleSidecarStateChange = () => {
    if (isEditMode && isDirty) {
      return;
    }

    handleSidecarOpenChange();
  };

  useEffect(() => {
    console.log('sidecar open state changed', { isSidecarOpen });
  }, [isSidecarOpen]);

  return (
    <Sidecar isOpen={isSidecarOpen} onOpenChange={handleSidecarStateChange}>
      <div className="flex flex__dir--column flex__ai--stretch h-full">
        {isLoadingOrganization && <DotsLoader />}

        {isError && <LoadingErrorHint />}

        {organization && (
          <>
            <Sidecar.Title>
              <div className="organization-detail-header flex flex__ai--center m-bottom-xxl" style={{ maxWidth: '80%' }}>
                <h2 className="title m-right-s" style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
                  {organization.name}
                </h2>

                <InvitationStatus bordered status={organization.adminStatus} />
              </div>
            </Sidecar.Title>
            <div className="sidecar__details box box-remove-padding">
              <div className="sidecar__tabs-navigation">
                <TabsNavigationSidecar
                  routes={[
                    {
                      label: t('organizationDetails.info'),
                      path: 'info',
                      icon: 'info',
                    },
                    {
                      label: t('organizationDetails.logs'),
                      path: 'logs',
                      icon: 'archive',
                    },
                  ]}
                />
              </div>
              <div className="sidecar__outlet-wrapper">
                <SidecarRouterOutlet />
              </div>
            </div>
          </>
        )}
      </div>
    </Sidecar>
  );
}
